import { Map } from 'immutable'
import { createSelector } from 'reselect'


export const root = (state) => state.get('reveal')

export const dataById = (state) => state.getIn(['reveal', 'dataByEndUserId'])

const _endUserIdFromProps = (state, { endUserId }) => {
  return endUserId
}

export const makeGetEndUserReveal = () => {
  return createSelector(
    dataById,
    _endUserIdFromProps,
    (revealData, endUserId) => {
      return revealData.get(endUserId, Map())
    })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/reveal/selectors.js